import moment from "moment";
import { ModalComponentProps } from "../../types";
import { underscoreToCapitalizeString } from "../../utils/utils";
import CustomModal from "../ui/CustomModal";

export const statusList = {
  pending: {
    text: "Pending for Approval",
    style: "status-warning",
  },
  complete: {
    text: "Approved by Line Manager",
    style: "status-success",
  },
  reject: {
    text: "Reject by Line Manager",
    style: "status-danger",
  },
  kpiStart: {
    text: "KPI Setup Start",
    style: "status text-[#fe832b] bg-[#FFF5F4]",
  },
  appraisalStart: {
    text: "Appraisal Start",
    style: "status text-[#4A72FF] bg-[#F2F5FF]",
  },
  promotion_applied: {
    text: "Promotion Applied",
    style: "status-success",
  },
  promotion_not_applied: {
    text: "Promotion Nor Applied",
    style: "status-danger",
  },
};

export default function LogViewModalKPI({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<{ log: any; kpi: string } | undefined>) {
  const logList = data?.log?.map((el: any) => ({
    title: data?.kpi,
    time: el?.created_at
      ? moment(el?.created_at).format("hh:mm A - MMM DD, YYYY")
      : "-",
    status:
      el?.payload?.status ||
      el?.newStatus ||
      ((el?.positionStatus || el?.entity_type) === "kpi"
        ? "kpiStart"
        : "appraisalStart"),
    note:
      el?.payload?.lineManagerComment ||
      underscoreToCapitalizeString(el?.action),
    id: el?.id,
  }));

  return (
    <>
      <CustomModal
        title="Log View"
        {...rest}
        handleClose={handleClose}
        width={800}
        footer={null}
      >
        <table className="min-w-full">
          <thead className="bg-[#F7FAFF] pb-2">
            <tr>
              <th
                className="border-b  py-2 text-left text-zinc-700 text-sm font-medium"
                style={{ borderBottomColor: "#8897AE" }}
              >
                Status
              </th>
              <th
                className="border-b  py-2 text-left text-zinc-700 text-sm font-medium"
                style={{ borderBottomColor: "#8897AE" }}
              >
                Submitted Time
              </th>
              <th
                className="border-b  py-2 text-left text-zinc-700 text-sm font-medium"
                style={{ borderBottomColor: "#8897AE" }}
              >
                Feedback
              </th>
            </tr>
          </thead>

          <br />

          <tbody>
            {logList?.map((el: any) => {
              const status =
                (el?.status as keyof typeof statusList) || "pending";
              const st = statusList[status];

              return (
                <tr className="align-top py-2" key={el?.id}>
                  <td className="">
                    <div className="relative pl-6 pb-0">
                      <div className="absolute left-[4px] top-0 w-[2px] h-full rounded-full bg-[#D7DFE9]"></div>

                      <div className="absolute left-0 top-5 w-2.5 h-2.5 rounded-full bg-[#1DB469]"></div>

                      <div className="self-stretch justify-start text-zinc-700 text-sm font-medium mb-1.5">
                        {el?.title}
                      </div>

                      <div className="pb-2">
                        <span className={st?.style}>{st?.text}</span>
                      </div>
                    </div>
                  </td>

                  <td className="py-2">
                    <div className="text-slate-500 text-sm font-medium">
                      {el?.time}
                    </div>
                  </td>

                  <td className="py-2">
                    <div className="text-slate-500 text-sm font-medium">
                      {el?.note}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CustomModal>
    </>
  );
}
